import { ref, computed, watch } from 'vue'
import axios, { addTask } from '@/plugin/axios'
import { sleep } from '@/util/common'
export let pageTitle = ref('')
export const allAreaList = ref([])
export const userInfo = ref(null)
export const token = ref(localStorage.getItem('bm_agency_token'))
export const showLoginBox = ref(false)

export const agencyId = computed(() => {
  return userInfo.value?.agencyId || '1859800001952165889'
})

export let areaList = ref([])

watch(token, (val) => {
  localStorage.setItem('bm_agency_token', val)
})

export const areaListWithAll = computed(() => {
  return [{ id: -1, name: '全国' }].concat(areaList.value)
})

export function getAreaList() {
  return axios.get('/boom-center-admin-service/sysAdmin/area-settings/page?size=100').then(res => {
    areaList.value = res.list
    sessionStorage.setItem('allAreaList', JSON.stringify(res.list))
    return res
  })
}

export function updateUserInfo(data) {
  return axios.put(`/boom-center-admin-service/agency/user/update`, { 
    ...data, 
    id: userInfo.value.id 
  }).then((res) => {
    userInfo.value = { ...userInfo.value, ...data }
    return res
  })
}

export function alterPassword({ oldPassword, newPassword, newPassword2 }) {
  return axios.post(`/boom-center-admin-service/agency/user/renewPassword`, {
    id: userInfo.value.id,
    oldPassword,
    password: newPassword,
    passwordConfirm: newPassword2,
    passwordGenerationMode: 0,
    renewType: 2
  })
}

export function getUserInfo() {
  if(!token.value) return Promise.reject('未登录')
  if(userInfo.value) return userInfo.value
  return addTask('getUserInfo', () => {
    return axios.get(`/boom-center-admin-service/agency/user/currentLoginInfo`).then(res => {
      if(!res.id) {
        token.value = ''
        ElMessage.error('您已被系统移除，请联系管理员')
        location.href = '/account/login'
        return Promise.reject('账户已被删除')
      }
      userInfo.value = res
      return res
    })
  })
  // return {}
}

export function login({ mobile, password }) {
  return axios.post('/boom-center-admin-service/agency/user/login', { phoneNumber: mobile, password }).then(res => {
    token.value = res.accessToken
    userInfo.value = res
    return res
  })
}

export function logout() {
  return sleep(0.1).then(() => {
    token.value = ''
    userInfo.value = null
  })
}
